<template>
  <div class="ws-input-card">
    <div
      v-if="title"
      class="ws-input-card__title text-center"
    >{{title}}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  props: {
    title: {
      type: String,
      default: null
    },
    maxWidth: {
      type: Number,
      default: 460
    }
  }
};
</script>

<style lang="scss">
@import "../assets/scss/ws-input-card.scss";
</style>